<template lang="html">
  <!-- <div class="bgImageMain">

<HubHeader></HubHeader> -->
  <!-- <div class="row pt-5 "> -->

  <div id="landingPage" class="row pt-5">
    <!-- <div class="col-12" id="topMargin">

    </div> -->
    <div class="col-1" id="leftSidebar">

    </div>
    <div class="col-10" id="middle">
      <div style="height: 12vh;">

      </div>
      <div class="row">
        <div class="col-2">

        </div>
        <div class="col-2">
          <a target="_blank" @click="setActiveNSWPort('portBotany')">
            <b-img src='img/mainpage/PortBotany.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a target="_blank" @click="setActiveNSWPort('portKembla')">
            <b-img src='img/mainpage/PortKembla.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a target="_blank" @click="setActiveNSWPort('enfield')">
            <b-img src='img/mainpage/EnfieldIntermodal.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a target="_blank" @click="setActiveNSWPort('cooksRiver')">
            <b-img src='img/mainpage/CooksRiverIntermodal.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
      </div>
      <div style="height:4vh;">

      </div>
      <div class="row">
        <!-- <div class="col-3">

        </div>
        <div class="col-2">
          <a :href="projectLinks.messageBoard" target="_blank">
            <b-img src='img/main_icons/communication_tool.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a :href="projectLinks.timesheet" target="_blank">
            <b-img src='img/main_icons/timesheet.png' fluid alt="..." rounded/></b-img>
          </a>
        </div>
        <div class="col-2">
          <a :href="projectLinks.contactList" target="_blank">
            <b-img src='img/main_icons/contact_list.png' fluid alt="..." rounded/></b-img>
          </a>
        </div> -->
      </div>
    </div>
    <div class="col-1 " id="rightSidebar">
      <!-- <a class="col-12 align-right" :href="softwareLinks.projectwise" target="_blank">
        <b-img src='img/software_icons/projectwise.png' fluid alt="..." rounded/></b-img>
      </a>
      <a class="col-12" :href="softwareLinks.bim360" target="_blank">
        <b-img src='img/software_icons/bim360.png' fluid alt="..." rounded/></b-img>
      </a>
      <a class="col-12" :href="softwareLinks.software3" target="_blank">
        <b-img src='img/software_icons/software3.png' fluid alt="..." rounded/></b-img>
      </a>
      <a class="col-12" :href="softwareLinks.software4" target="_blank">
        <b-img src='img/software_icons/software4.png' fluid alt="..." rounded/></b-img>
      </a>
      <a class="col-12" :href="softwareLinks.teams" target="_blank">
        <b-img src='img/software_icons/msteams.png' fluid alt="..." rounded/></b-img>
      </a> -->
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
// import HubHeader from "../layout/HubHeader.vue";
// import HubFooter from "../layout/HubFooter.vue";
export default {
  name: "MainPage",
  // components: {
  //   HubHeader,
  //   // HubFooter
  // },
  data() {
    return {
    }
  },
  methods: {
    setActiveNSWPort: function(port){
      const current = this
      // this.$store.state.mainStore.nswPorts
      console.log(current.$store.state.mainStore.nswPorts[port]);
      current.$store.commit("mainStore/setActiveNSWPort", current.$store.state.mainStore.nswPorts[port])
      current.$router.push("/LandingPage")
      // const filtered = Object.keys(this.$store.state.mainStore.nswPorts)
      //   .filter(key=>{
      //     console.log(key);
      //     return key == port
      //   });
      //
      // console.log(filtered);
    }
  }
}
</script>

<style>
/* .bgImageMain {
  background-size: 100vw 94.5vh;
  background-blend-mode: lighten;
  background-repeat: no-repeat;
  background-image: url("/img/nswportBG6.png");
  height: 94.5vh;
  width: auto;
} */
</style>
